export const VUEX_LOCALIZATION_CHANGE_LANG = 'VUEX_LOCALIZATION_CHANGE_LANG'
export const VUEX_LOCALIZATION_CHANGE_PRODUCT_LANG = 'VUEX_LOCALIZATION_CHANGE_PRODUCT_LANG'
